import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import Operation from "core/models/Operation";
import BoundOperationSet from "core/models/BoundOperationSet";
var OperationSet = Backbone.Collection.extend({
  model: Operation,

  /**
   * Generates a set of bound operations for all operations in the set.
   * @param  {Function} modelGetter A function which, executed under the context of `context`, returns the model to supply to `action` and `available`.
   * @param  {Function} success     A function to execute on success of `action`.
   * @param  {Function} error       A function to execute on error of `action`.
   * @return {BoundOperationSet}             The set of bound operations.
   */
  bindAll: function (modelGetter, success, error) {
    return new BoundOperationSet(
      _.map(this.models, function (operation) {
        return operation.bind(modelGetter, success, error);
      }),
      {
        parent: this,
      }
    );
  },
});

export default OperationSet;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/models/OperationSet.js
// module id = 75
// module chunks = 1